import React, { Fragment, useState, useEffect } from 'react'
import { Table } from 'antd'
import { NoData, PageAlert, TableContainer } from 'components'
import { freeSearch } from 'utils/search'
import EmptyAccountsList from 'views/Administration/Account/AccountList/EmptyAccountsList'
import AccountsListTop from 'views/Administration/Account/AccountList/AccountsListTop'
import AccountsListColumns from 'views/Administration/Account/AccountList/AccountsListColumns'

const SEARCH_ACCOUNTS_MAPPING = {
  name: 'name',
  account_type: 'account_type'
}

function AccountList({ data, loading, error, handleEnableAccount, listAccount }) {
  const [searchData, setSearchData] = useState(data)

  const handleSearch = term => {
    if (term && term.length) setSearchData(freeSearch(searchData, term, SEARCH_ACCOUNTS_MAPPING))
    else {
      setSearchData(data)
    }
  }

  useEffect(() => {
    setSearchData(data);
  }, [data])
  
  return (
    <Fragment>
      {error && <PageAlert message={error} />}
      <AccountsListTop listAccount={listAccount} onSearch={handleSearch} />
      <TableContainer>
        {!data && !loading && <EmptyAccountsList />}
        {data && !loading && (
          <Fragment>
            <Table
              rowKey="id"
              pagination={{ hideOnSinglePage: true }}
              columns={AccountsListColumns({handleEnableAccount})}
              dataSource={searchData}
              loading={loading}
              locale={{
                emptyText: <NoData />
              }}
            />
          </Fragment>
        )}
      </TableContainer>
    </Fragment>
  )
}

export default AccountList